export default "__VITE_ASSET__D_la91BG__"